import { FormLabel, styled } from '@mui/material'

export const HicFormLabel = styled(FormLabel)(() => ({
  fontFamily: 'Roboto, Cairo',
  fontSize: '14px',
  fontWeight: 500,
}))
